import {Dictionary} from "../../components/Dictionary";
import {AdminComponent} from "../../components/AdminComponent";
import {Loader} from "../../components/Loader";
import React, {ReactElement} from "react";
import {DateTime} from "../../components/ListComponent/DateTime";
import {Util} from "../../components/Util";
import {SubScriptionInfoElement} from "./SubScriptionInfoElement";

export class StatusInfoAll extends AdminComponent {
    protected dictionary: Dictionary = new Dictionary();
    protected static keyNo: number = 0;


    componentDidMount() {
        this.request.fetch('/order/info/all', null, {method: 'GET'})
            .then((state: { item: { [key: string]: string } } | any) => {
                this.setState(state);
            }).catch(error => {
            this.onError(error);
        });
    }

    getKeyValue() {
        StatusInfoAll.keyNo++;
        return "home:" + StatusInfoAll.keyNo;
    }

    protected getInfoPanel(): ReactElement {
        return (<></>);
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const state = this.state;
        const dictionary = this.dictionary;
        const orderStatuses: string[] = [
            'draft', 'import-error', 'unknown-product', 'open', 'create-error', 'in-transit', 'cancelled', 'sync-error', 'completed', 'close-error', 'closed', 'error',
            'address-error', 'insufficient-quantity', 'duplication-error', 'customer-error', 'scheduled', 'on-hold', 'b2b-open', 'b2b-in-transit', 'archived'
        ];

        const orderStatusesB2b: string[] = [
            'draft', 'import-error', 'unknown-product', 'open', 'create-error', 'in-transit', 'cancelled', 'sync-error', 'completed', 'close-error', 'closed', 'error',
            'address-error', 'insufficient-quantity', 'duplication-error', 'customer-error', 'scheduled', 'on-hold', 'b2b-open', 'b2b-in-transit', 'archived'
        ];

        const inboundStatuses: string[] = ['draft', 'import-error', 'unknown-product', 'open', 'create-error', 'in-transit', 'cancelled', 'sync-error', 'completed', 'close-error', 'closed', 'error'];
        const outboundStatuses: string[] = inboundStatuses;
        const transferStatuses: string[] = inboundStatuses;

        const defineColorByStatus = Util.getColorByStatus;
        const classNamePrefix = "tile col-4 col-lg-3 col-xl-2 col-xxl-1 ";

        const getKeyValue = this.getKeyValue;
        let suffix: any = [];
        if (state?.start) {
            suffix.push('created_from=' + DateTime.atom(state.start));
        }
        if (state?.end) {
            suffix.push('created_to=' + DateTime.atom(state.end));
        }
        suffix = suffix.length ? '&' + suffix.join('&') : '';
        return (
            <>
                <SubScriptionInfoElement items={this.state?.subscription}/>
                <div className="row">
                    {this.getInfoPanel()}
                </div>
                <div className="row">
                    <h4>B2C {this.dictionary.get['orders']}
                        <br/><small>(B2C Orders / B2C SalesOrder / Retail Order)</small>
                    </h4>
                    <div className="x-form" key="orders:status-list">
                        <div className="row">
                            {orderStatuses.map(function (elem: string) {
                                if (elem === 'newLine') {
                                    return (<div className="row" key={getKeyValue()}>&nbsp;</div>);
                                }
                                const className: string = classNamePrefix + defineColorByStatus(elem)
                                let link = '/order/list#type=B2C&status=' + elem + suffix;
                                return (
                                    <a className={className} href={link} key={getKeyValue()}>
                                        <p>
                                            <span>{typeof state.ordersB2C[elem] !== 'undefined' ? state.ordersB2C[elem] : '-'}</span>
                                            {dictionary.get[elem]}
                                        </p>
                                    </a>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <h4>B2B {this.dictionary.get['orders']}
                        <br/><small>(B2B Orders / B2B SalesOrder / Business Order)</small>
                    </h4>
                    <div className="x-form" key="orders:status-list">
                        <div className="row">
                            {orderStatusesB2b.map(function (elem: string) {
                                if (elem === 'newLine') {
                                    return (<div className="row" key={getKeyValue()}>&nbsp;</div>);
                                }
                                const className: string = classNamePrefix + defineColorByStatus(elem)
                                const link = '/order/list#type=B2B&status=' + elem + suffix;
                                return (
                                    <a className={className} href={link} key={getKeyValue()}>
                                        <p>
                                            <span>{state.ordersB2B[elem] || '-'}</span>
                                            {dictionary.get[elem]}
                                        </p>
                                    </a>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <h4>{this.dictionary.get['inbound']}
                        <br/><small>(Goods Receipt (GR) / Inbound Delivery / Warehouse Receipt / Purchase Order)</small>
                    </h4>
                    <div className="x-form">
                        <div className="row">
                            {inboundStatuses.map(function (elem: string) {
                                if (elem === 'newLine') {
                                    return (<div className="row" key={getKeyValue()}>&nbsp;</div>);
                                }
                                const className: string = classNamePrefix + defineColorByStatus(elem)
                                const link = '/receipt/list#status=' + elem + suffix;
                                return (
                                    <a className={className} href={link} key={getKeyValue()}>
                                        <p>
                                            <span>{state.inbound[elem] || '-'}</span>
                                            {dictionary.get[elem]}
                                        </p>
                                    </a>

                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <h4>{this.dictionary.get['outbound']}
                        <br/><small>(Goods Issue (GI) / Outbound Delivery / Purchase Return Order / Warehouse
                            Shipment)</small>
                    </h4>
                    <div className="x-form">
                        <div className="row">
                            {outboundStatuses.map(function (elem: string) {
                                if (elem === 'newLine') {
                                    return (<div className="row" key={getKeyValue()}>&nbsp;</div>);
                                }
                                const className: string = classNamePrefix + defineColorByStatus(elem)
                                const link = '/shipment/list#status=' + elem + suffix;
                                return (
                                    <a className={className} href={link} key={getKeyValue()}>
                                        <p>
                                            <span>{state.outbound[elem] || '-'}</span>
                                            {dictionary.get[elem]}
                                        </p>
                                    </a>

                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <h4>{this.dictionary.get['transfer-product']}
                        <br/><small>(Inter-Warehouse Transfer / Inter Company Transfer / Transfer Order)</small>
                    </h4>
                    <div className="x-form">
                        <div className="row">
                            {transferStatuses.map(function (elem: string) {
                                if (elem === 'newLine') {
                                    return (<div className="row" key={getKeyValue()}>&nbsp;</div>);
                                }
                                const className: string = classNamePrefix + defineColorByStatus(elem)
                                const link = '/transfer-product/list#status=' + elem + suffix;
                                return (
                                    <a className={className} href={link} key={getKeyValue()}>
                                        <p>
                                            <span>{state.transfer[elem] || '-'}</span>
                                            {dictionary.get[elem]}
                                        </p>
                                    </a>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
